import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import ImageWrapper from './ImageWrapper';
import ContactModal from './ContactModal';
import { colors } from '../styles';

const styles = css`
  display: none;
  position: fixed;
  left: 0;
  bottom: 0;
  height: 55px;
  width: 100%;
  background-color: ${colors.white};
  z-index: 10;
  @media (min-width: 992px) {
    display: none;
  }
  .OSCMobileTag_wrapper {
    display: flex;
    height: 100%;
  }
  .OSCMobileTag_imageWrapper {
    width: 65px;
    height: 100%;
    overflow: hidden;
    @media (max-width: 359.98px) {
      width: 58px;
    }
  }
  .OSCMobileTag_content {
    display: flex;
  }
  .OSCMobileTag_headlineWrapper {
    display: flex;
    align-items: center;
  }
  .OSCMobileTag_headline {
    font-size: 11px;
    font-weight: bold;
    letter-spacing: 0.116364em;
    line-height: 1.363636;
    text-transform: uppercase;
    color: ${colors.color1};
    margin-left: 11px;
    span {
      display: block;
      font-size: 17px;
      letter-spacing: 0.1em;
      color: ${colors.color1Dark};
    }
    @media (max-width: 359.98px) {
      margin-left: 7px;
      span {
        font-size: 14px;
      }
    }
  }
  .OSCMobileTag_list {
    list-style: none;
    padding: 0;
    display: flex;
    flex-shrink: 0;
    margin: 0 0 0 auto;
  }
  .OSCMobileTag_contactModal {
    height: 100%;
  }
  .OSCMobileTag_listItem {
    border-left: 1.5px solid ${colors.color2};
    &:first-of-type{
      border-left: none;
    }
    a, span[role="button"] {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 48px;
      height: 100%;
      @media (min-width: 365px) {
        width: 54px;
      }
    }
    img[src*="text"] {
      width: 22px;
      height: auto;
    }
    img[src*="email"] {
      width: 20px;
      height: auto;
    }
    img[src*="phone"] {
      width: 19px;
      height: auto;
    }
  }
`;

function OSCTagMobile({ agent, builder }) {
  return (
    <div className={styles} >
      <div className="OSCMobileTag_wrapper">
        <div className="OSCMobileTag_headlineWrapper">
          <ImageWrapper
            className="OSCMobileTag_imageWrapper"
            src={get(agent, 'logo.contentUrl')}
            alt={get(agent, 'primary_osc') ? '' : get(agent, 'name', '')}
            width={90}
            height={90}
          />
          <div className="OSCMobileTag_headline">Questions?<span>Let’s Talk!</span></div>
        </div>
        <ul className="OSCMobileTag_list align-items-center">
          {  // <li className="OSCMobileTag_listItem">
            //   <a href={`sms:${get(builder, 'text_number', '')
            // .replace(/[^0-9]/g, '')}`}>
            //     <img src="/images/i-text.svg" alt="text us" />
            //   </a>
            // </li>
          }
          <li className="OSCMobileTag_listItem">
            <ContactModal className="OSCMobileTag_contactModal" builder={builder}>
              <img src="/images/i-email.svg" alt="contact us" />
            </ContactModal>
          </li>
          <li className="OSCMobileTag_listItem">
            <a href={`tel:${get(builder, 'telephone', '').replace(/[^0-9]/g, '')}`}>
              <img src="/images/i-phone.svg" alt="call us" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}

OSCTagMobile.propTypes = {
  agent: PropTypes.object.isRequired,
  builder: PropTypes.object.isRequired,
};

export default OSCTagMobile;



// WEBPACK FOOTER //
// ./src/components/OSCTagMobile.js